import React from "react";
import ReactDOM from "react-dom";

import App from "./App";
import fetch from "./utils/fetch";
import reportWebVitals from "./reportWebVitals";
import { toast } from "react-toastify";

import { useActiveClientIdStore } from "../src/store/activeClientId";
import { useActiveClientStore } from "../src/store/activeClient";
import { useSocketDataStore } from "../src/store/socketData";

import { ErrorBoundary } from "react-error-boundary";

require("./assets/css/main.scss");
require("./assets/css/bootstrap.min.css");

window.addEventListener("unhandledrejection", (event) => {
    event.preventDefault();
    console.error("Unhandled promise rejection:", event.reason);
    // toast.error("Something went wrong. Please try again.", {
    //     position: "top-center",
    //     autoClose: 5000,
    // });
});

const Root = () => {
    const activeClientId = useActiveClientIdStore<any>((s) => s.activeClientId);
    const activeClient = useActiveClientStore<any>((s) => s.activeClient);
    const socketCallQueue = useSocketDataStore<any>((s) => s.socketCallQueue);
    const socketCallStatus = useSocketDataStore<any>((s) => s.socketCallStatus);

    const handleError = async (error: any, info: any) => {
        const sendError = async (error: any, info: any) => {
            const a = new fetch(
                "/user/vca/create/error",
                {
                    error: {
                        error: error.toString(),
                        stack: error.stack,
                        component_stack: info.componentStack,
                        info: info,
                        active_client_id: activeClientId,
                        active_client: activeClient,
                        socket_queue: socketCallQueue,
                        socket_status: socketCallStatus,
                    },
                },
                { success: false, error: false },
            ).post();
            a.then(async (res) => {
                if (res.status === "error" || res === false) {
                    await sendError(error, info);
                }
            }).catch(async (e) => {
                await sendError(error, info);
            });
        };
        await sendError(error, info);
    };

    return (
        <ErrorBoundary
            fallback={
                <div>
                    <h1 style={{ padding: "30px" }}>Something went wrong, this error has been reported and tracked. Please refresh the page.</h1>
                </div>
            }
            onError={handleError}>
            <App />
        </ErrorBoundary>
    );
};

ReactDOM.render(<Root />, document.getElementById("root"));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

/*
import React from "react";
import ReactDOM from "react-dom";

import App from "./App";
import fetch from "./utils/fetch";
import reportWebVitals from "./reportWebVitals";

import { useActiveClientIdStore } from "../src/store/activeClientId";
import { useActiveClientStore } from "../src/store/activeClient";

import { ErrorBoundary } from "react-error-boundary";

require("./assets/css/main.scss");
require("./assets/css/bootstrap.min.css");

const activeClientId = useActiveClientIdStore<any>((s) => s.activeClientId);
const activeClient = useActiveClientStore<any>((s) => s.activeClient);

ReactDOM.render(
    // <React.StrictMode>
    <ErrorBoundary
        fallback={
            <div>
                <h1 style={{ padding: "30px" }}>Something went wrong, this error has been reported and tracked. Please refresh the page.</h1>{" "}
            </div>
        }
        onError={async (error, info) => {
            const send = async (error: any, info: any) => {
                const a = new fetch(
                    "/user/vca/create/error",
                    {
                        error: { error: error.toString(), info: info, active_client_id: activeClientId, active_client: activeClient },
                    },
                    { success: false, error: false }
                ).post();
                a.then(async (res) => {
                    if (res.status === "error" || res === false) {
                        await send(error, info);
                    }
                }).catch(async (e) => {
                    await send(error, info);
                });
            };
            await send(error, info);
        }}
    >
        <App />
    </ErrorBoundary>,
    // </React.StrictMode>,
    document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
*/
